
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../Components/Ui/tables/Actions";
import { useNavigate } from "react-router-dom";
import { useDeleteProject } from "../../api/Project";
import ColumnsImage from "../../Components/Columns/ColumnsImage";


const useTableColumns :any = () => {
  const [t] = useTranslation();
  const deleteMutation = useDeleteProject()
  const navigate = useNavigate()
    return useMemo(
    () => [
 
      {
        name: t("id"),
        sortable: true,
        center: true,
        selector: (row: any) => row.id, 
      }, 
      {
        name: t("logo"),
        sortable: false,
        center: "true",
        cell: (row:any) =>  {
          let src = row?.logo;
          return <ColumnsImage src={src} />
        }
        
      },
      {
        name: t("type"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.type
      },
      {
        name: t("title"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.title
      },

      {
        name: t("description"),
        sortable: false,
        center: "true",
        cell: (row:any) => <div className="single-line-div">{row?.description} </div> 
      },
      {
        name: "#",
        sortable: false,
        center: true,
        cell: (row:any) => (
          <Actions
            objectToEdit={row}
            showEdit
            onEdit={()=> navigate(`/project/${row.id}`) }
            showView={false}
            onDelete={() => deleteMutation.mutate({ id: row.id })}
          >  
          </Actions>
        ),
      },

    ],
    [deleteMutation, navigate, t]
  );
};

export default useTableColumns;

